<template>
  <div>
    <v-tabs  div="tabs">
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
            href="#"
            v-model="tabs"
            v-for="tab in tabs"
            :key="tab.name"
            @click="setActiveTabName(tab.name)"
          >{{tab.displayName}}</v-tab>
        </v-tabs>
        <div v-if="displayContents('table')">
          <v-toolbar flat color="white" pt-4 mt-4>
      <v-btn round color="primary" @click="addItem()">Add Inventory Item</v-btn>
      <v-btn round color="primary">
        <download-csv
    :data="barcodeData"
    name="qrCode.csv">
    Download QR Code CSV
      </download-csv>
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" label="Search"></v-text-field>
    </v-toolbar>
    <v-data-table
    id="printTable"
      :headers="headers"
      class="elevation-1"
      :items="stockitems"
      :rows-per-page-items="[25, 50, 100]"
      :search="search"
      item-key="id"
      align-center
      style="cursor: pointer"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">
            <v-icon @click="editItem(props.item)">edit</v-icon>
          <v-icon @click="deleteItem(props.item)">delete</v-icon>
        </td>
        <td  class="text-xs-center">{{props.item.name}}</td>
        <td  class="text-xs-center">{{props.item.stockType.name}}</td>
      </template>
      <template
        v-slot:pageText="props"
      >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
    </v-data-table>

    <v-dialog v-model="addInventoryItem" max-width="750px">
      <v-card flat color="white">
        <v-toolbar color="primary">
          <h1 class="headline white--text">ADD INVENTORY ITEM</h1>
        </v-toolbar>
        <v-card-text>
          <v-layout>
            <v-flex xs6 mx-1>
          <v-text-field label="Name" v-model="item.name"></v-text-field>
            </v-flex>
            <v-flex xs6 mx-1>
          <v-autocomplete
          v-model="item.stockTypeId"
          :items="stocktypes"
          label="Inventory Type"
          item-text="name"
          item-value="id"
          ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout>
          <v-flex mx-1>
           <v-checkbox
                  v-model="item.isSaleable"
                  label="Sellable"
            ></v-checkbox>
          </v-flex>
          <v-flex v-if="accountingInfo.length>0&&item.isSaleable">
            <v-autocomplete v-if="$store.state.currentOrg.org.accountingSystem == 'SageOne'"
            ref="accountCode" v-on:blur="$refs['accountCode'].blur()"
            :items="accountingInfo"
            item-text="name"
            item-value="id"
            label="Associated Account"
            v-model="item.accountCode"
            ></v-autocomplete>
          </v-flex>
        <v-flex xs6 mx-1>
        <v-text-field v-if="item.isSaleable" label="Price (excl. VAT)" type="number" v-model="item.priceExclVat"></v-text-field>
        </v-flex>
          </v-layout>
          <v-layout>
            <v-textarea v-model="item.description" label="Description"></v-textarea>
          </v-layout>
          <v-layout>
          <v-flex xs6 mx-1>
        <v-btn class="primary" dark round @click="$refs.file.click()">Upload Image</v-btn>
        <input style="display: none" class="file-input"
         @change="selectFile($event)"  ref="file" type="file">
          </v-flex>
            <v-flex xs6 mx-1>
            <v-img v-if="item.image!==null"
                :key="key"
                :src="item.image"
                max-height="150px"
                contain
              ></v-img> 
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="addInventoryItem=false, item={}">Cancel</v-btn>
            <v-btn round color="primary" v-if="item.name && item.stockTypeId" @click="saveInventoryType">Save</v-btn>
            <v-btn round color="primary" v-else disabled>Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editInventoryItem" max-width="750px">
        <v-toolbar color="primary">
          <h1 class="headline white--text">EDIT INVENTORY ITEM</h1>
        </v-toolbar>
         <v-toolbar flat color="white">
               <v-tabs>
          <v-tabs-slider color="primary"></v-tabs-slider>
          <v-tab
            @click="basicInformation=true;showCode=false"
            class="grey--text"
            flat
            round
            color="grey"
          >Basic Information</v-tab>
          <v-tab
            @click="basicInformation=false;showCode=true"
            class="grey--text"
            flat
            round
            color="grey"
          >QR Code</v-tab>
        </v-tabs>
            </v-toolbar>
       <v-card flat>
        <v-card flat v-show="basicInformation">
           <v-card-text>
          <v-layout>
            <v-flex xs6 mx-1>
          <v-text-field label="Name" v-model="item.name"></v-text-field>
            </v-flex>
            <v-flex xs6 mx-1>
          <v-autocomplete
          v-model="item.stockTypeId"
          :items="stocktypes"
          label="Inventory Type"
          item-text="name"
          item-value="id"
          ></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout>
          <v-flex  mx-1>
           <v-checkbox
                  v-model="item.isSaleable"
                  label="Sellable"
            ></v-checkbox>
          </v-flex>
          <v-flex v-if="accountingInfo.length>0&&item.isSaleable">
            <v-autocomplete v-if="$store.state.currentOrg.org.accountingSystem == 'SageOne'"
            ref="accountCode" v-on:blur="$refs['accountCode'].blur()"
            :items="accountingInfo"
            item-text="name"
            item-value="id"
            label="Associated Account"
            v-model="item.accountCode"
            ></v-autocomplete>
          </v-flex>
        <v-flex xs6 mx-1>
        <v-text-field v-if="item.isSaleable" label="Price (excl. VAT)" type="number" v-model="item.priceExclVat"></v-text-field>
        </v-flex>
          </v-layout>
          <v-layout>
            <v-textarea v-model="item.description" label="Description"></v-textarea>
          </v-layout>
          <v-layout>
          <v-flex xs6 mx-1>
        <v-btn class="primary" dark round @click="$refs.file.click()">Upload Image</v-btn>
        <input style="display: none" class="file-input"
         @change="selectFile($event)"  ref="file" type="file">
          </v-flex>
            <v-flex xs6 mx-1>
            <v-img v-if="item.image!==null"
                :key="key"
                :src="item.image"
                max-height="150px"
                contain
              ></v-img> 
            </v-flex>
          </v-layout>
           </v-card-text>
        </v-card>
         <v-card flat v-show="showCode">
           <v-card-text>
          <qrcode :value="item.qrValue"  />
        </v-card-text>
         </v-card>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="editInventoryItem=false, item={}">Cancel</v-btn>
            <v-btn round color="primary" v-if="item.name && item.stockTypeId" @click="saveEditedInventoryItem">Save</v-btn>
            <v-btn round color="primary" v-else disabled>Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
        </div>
        <div v-if="displayContents('qrCode')" id="qrCodeArray">
          <v-toolbar flat color="white">
            <v-btn color="primary" class="white--text" round @click="print('qrCodeArray')">Print</v-btn>
          </v-toolbar>
          <QrCodeArray id="qrCodeArray"/>
        </div>

  </div>
</template>

<script>
import Api from "@/services/Api";
import Qrcode from 'vue-qrcode'
import QrCodeArray from "@/components/QrCodeArray.vue";
export default {
  components: {
    Qrcode,
    QrCodeArray
  },
  props: ["stockitems", "stocktypes"],
  data() {
    return {
      accountingInfo: [],
      basicInformation:false,
      showCode:false,
      key:0,
      printer_off: true,
      addInventoryItem: false,
      editInventoryItem: false,
      search: '',
      d: null,
      item:{
        image:null,
        isSaleable:true},
      barcodeData: [],
      activeTabName: '',
      tabs: [
        { name: "table", displayName: "Table" },
        { name: "qrCode", displayName: "QR Codes" }
      ],
      headers: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Stock Type",
          align: "center",
          value: "stockType.name"
        }
      ]
    };
  },
  watch: {
    async stockitems(value){
      if(value.length>0){
        this.barcodeData = await this.stockitems.map(x=>({barcode: JSON.stringify({id: x.id, name: x.name, stockTypeId: x.stockTypeId, stockTypeName: x.stockType.name})}))
      }
    }
  },
  created(){
    this.activeTabName='table'
    if(this.$store.state.currentOrg.org.accountingSystem == 'SageOne'){
        if(this.$store.state.currentOrg.org.accountBasedAccounting){
        this.fetchSageAccounts()
        } else {
          this.fetchSageItems()
        }
      }
  },
  methods: {
    async fetchSageAccounts(){
      await Api().get('/sageOne/accounts').then(res=>{
        let result = res.data.Results.filter(x=>x.Category.ID == 1)
        this.accountingInfo = result.map(x=>({id: x.ID.toString(), name: x.Name}))
      })
    },
    async fetchSageItems(){
      await Api().get('/sageOne/items').then(res=>{
        this.accountingInfo = result.map(x=>({id: x.ID.toString(), name: x.Name}))
      })
    },
     async selectFile(event) {
     let file = event.srcElement.files[0];
    await this.uploadFile(file)
    },
    async uploadFile(file){
     var reader = await new FileReader();
     await reader.readAsDataURL(file);
     reader.onload = () => {     
     this.setResult(reader.result)
      }
     reader.onerror = function() {
        console.log('there are some problems');
    };
    },
    setResult(result){
      this.item.image=result
      this.key+=1          
    }, 
      editItem(item) {
        if(this.authUpdate(this.$store.state.currentRoute)){
      this.item = Object.assign({}, item);
      this.basicInformation=true,
      this.showCode=false
      this.editInventoryItem = true;
      this.item.qrValue = JSON.stringify({id: item.id, name: item.name, stockTypeId: item.stockTypeId, stockTypeName: item.stockType.name})
      }
    },
    deleteItem(item) {
        if(this.authDelete(this.$store.state.currentRoute)){
      confirm("Are you sure you would like to delete this Inventory Item?") &&
        Api()
          .put("/stockItem/" + item.id, {
            isActive: false,
            isDeleted: true
          })
          .then(this.$emit("stockItemChange"));
        }
    },
    addItem(){
        if(this.authCreate(this.$store.state.currentRoute)){
          this.item.isSaleable=true
            this.addInventoryItem=true
        }
    },
    saveInventoryType() {
      if(this.item.isSaleable==false){
        this.item.priceExclVat=0
      }
      Api()
        .post("/stockItem", {
          accountCode: this.item.accountCode,
          name: this.item.name,
          stockTypeId: this.item.stockTypeId,
          image: this.item.image,
          description: this.item.description,
          priceExclVat: this.item.priceExclVat,
          isSaleable: this.item.isSaleable,
          isActive: true,
          isDelete: false
        })
        .then(() => {
          (this.addInventoryItem = false),
            (this.item = {}),
            this.$emit("stockItemChange");
        });
    },
    saveEditedInventoryItem() {
      if(this.item.isSaleable==false){
        this.item.priceExclVat=0
      }
      Api()
        .put("/stockItem/"+this.item.id, {
          accountCode: this.item.accountCode,
          name: this.item.name,
          stockTypeId: this.item.stockTypeId,
          image: this.item.image,
          description: this.item.description,
          priceExclVat: this.item.priceExclVat,
          isSaleable: this.item.isSaleable,
          isActive: true,
          isDelete: false
        })
        .then(() => {
          (this.editInventoryItem = false),
            (this.item = {}),
            this.$emit("stockItemChange");
        });
    },
    print (componentId) {
      // Pass the element id here
      this.$htmlToPaper(componentId);
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
  }
};
</script>

<style>
</style>